import {
  EditButton,
  ListButton,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

const ShowActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <EditButton />
  </TopToolbar>
);

export const TrafficSourceShow = () => (
  <Show actions={<ShowActions />}>
    <SimpleShowLayout>
      <TextField source="title" />
      <TextField label="max Click ID Length" source="maxClickIdLength" />
      <TextField label="Created At" source="createdAt" />
      <TextField label="Updated At" source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
